<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 18 18">
    <g>
      <path
        d="M3.971,15H.75A.751.751,0,0,1,0,14.25V11.07a.749.749,0,0,1,.218-.533l8.2-8.2L10.537.218A.749.749,0,0,1,11.067,0h.007A.749.749,0,0,1,11.6.218l3.18,3.18A.746.746,0,0,1,15,3.93l-.053.037a.52.52,0,0,1,0,.105.749.749,0,0,1,0,.18.89.89,0,0,1-.165.247l-2.13,2.085L4.5,14.783A.753.753,0,0,1,3.971,15ZM8.948,3.93h0L1.5,11.378V13.5H3.623L11.07,6.053,8.948,3.93ZM11.07,1.815,10.005,2.873,12.128,5,13.185,3.93,11.07,1.815Z"
        transform="translate(1.5 1.5)"
        :fill="props.colorFill"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconCircleCheck',

  props: {
    size: { type: [String, Number], default: '16px' },
    colorFill: { type: String, default: '#5b73e8' },
  }
}
</script>